export default __webpack_public_path__ + "static/media/IMG-20250105-WA0029.c62704b7.jpg";